import React, {useEffect, useState} from 'react';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {TextField, InputAdornment, IconButton} from '@mui/material';
import {Event, KeyboardArrowLeft, KeyboardArrowRight} from '@mui/icons-material';
import {matchFilters} from 'app/components/stream/streamFilter.const';
import {FilterActionBtn} from 'app/components/floatingAction/FilterActionBtn';
import deLocale from 'date-fns/locale/de';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {computeSurroundingDates} from 'app/components/matchCalendar/DatePickerHelpers';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${SIZES[56]};
  background-color: ${COLORS.white};
  margin-bottom: ${SIZES[8]};
`;

const DatepickerContainer = styled.div`
  display: flex;
`;

const Space = styled.div`
  width: ${SIZES[42]};
  height: ${SIZES[40]};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SIZES[40]};
  height: ${SIZES[40]};
  cursor: pointer;
  border-radius: ${SIZES[20]};
  &:hover {
    background-color: ${COLORS.lightestGrey};
  }
`;

const streamRegex = /\/region\/[a-z0-9-]+\/matches/;

const filterLabels = {
  cancelled: 'Abg.',
  live: 'Live',
  default: 'Alle',
};

export const DateNavigation = ({categories, date, onChange}) => {
  const [currentDates, setCurrentDates] = useState(null);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (date) {
      const dates = computeSurroundingDates(date);
      setCurrentDates(dates);
    }
  }, [date]);

  const handleStepper = date => {
    if (date) {
      onChange(date);
    }
  };

  return (
    <Wrapper>
      <Space />
      <DatepickerContainer>
        <IconContainer onClick={() => handleStepper(currentDates?.prevDate)}>
          <KeyboardArrowLeft style={{color: COLORS.darkerGrey}} />
        </IconContainer>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={deLocale}>
          <DatePicker
            value={date}
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            onChange={onChange}
            desktopModeMediaQuery={'@media (pointer: none)'}
            toolbarTitle={''}
            showToolbar={false}
            componentsProps={{
              actionBar: {
                actions: ['today', 'cancel', 'accept'],
              },
            }}
            renderInput={params => (
              <TextField
                {...params}
                variant='outlined'
                size='small'
                InputProps={{
                  ...params.InputProps,
                  color: 'secondary',
                  sx: {
                    width: SIZES[148],
                    '& input': {
                      cursor: 'pointer',
                    },
                  },
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton edge='end' onClick={handleOpen}>
                        <Event />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </LocalizationProvider>
        <IconContainer onClick={() => handleStepper(currentDates?.nextDate)}>
          <KeyboardArrowRight style={{color: COLORS.darkerGrey}} />
        </IconContainer>
      </DatepickerContainer>
      <FilterActionBtn
        filterValues={matchFilters}
        regex={streamRegex}
        filterLabels={filterLabels}
        categories={categories}
      />
    </Wrapper>
  );
};
